<script setup lang="ts">
import { onMounted, watch } from 'vue'
import { useRoute } from 'vue-router'

interface SEOProps {
  title?: string
  description?: string
  keywords?: string
  image?: string
  url?: string
  type?: string
}

const props = withDefaults(defineProps<SEOProps>(), {
  title: 'Next School - Nền tảng giáo dục AI tiên tiến',
  description: 'Nền tảng giáo dục AI tiên tiến với chatbot thông minh, tạo bài giảng, trợ lý học tập và công cụ AI cho giáo viên và học sinh.',
  keywords: 'Next School, giáo dục AI, chatbot giáo dục, trợ lý học tập, AI cho giáo viên',
  image: '/src/assets/login/logoIcon.png',
  url: 'https://welcome.nextschool.app',
  type: 'website',
})

const route = useRoute()

const updateMetaTags = () => {
  const fullUrl = `${props.url}${route.path}`

  // Update title
  document.title = props.title

  // Update meta description
  let metaDescription = document.querySelector('meta[name="description"]')
  if (!metaDescription) {
    metaDescription = document.createElement('meta')
    metaDescription.setAttribute('name', 'description')
    document.head.appendChild(metaDescription)
  }
  metaDescription.setAttribute('content', props.description)

  // Update meta keywords
  let metaKeywords = document.querySelector('meta[name="keywords"]')
  if (!metaKeywords) {
    metaKeywords = document.createElement('meta')
    metaKeywords.setAttribute('name', 'keywords')
    document.head.appendChild(metaKeywords)
  }
  metaKeywords.setAttribute('content', props.keywords)

  // Update canonical URL
  let canonical = document.querySelector('link[rel="canonical"]')
  if (!canonical) {
    canonical = document.createElement('link')
    canonical.setAttribute('rel', 'canonical')
    document.head.appendChild(canonical)
  }
  canonical.setAttribute('href', fullUrl)

  const updateOpenGraphTag = (property: string, content: string) => {
    let meta = document.querySelector(`meta[property="${property}"]`)
    if (!meta) {
      meta = document.createElement('meta')
      meta.setAttribute('property', property)
      document.head.appendChild(meta)
    }
    meta.setAttribute('content', content)
  }

  const updateTwitterTag = (name: string, content: string) => {
    let meta = document.querySelector(`meta[name="${name}"]`)
    if (!meta) {
      meta = document.createElement('meta')
      meta.setAttribute('name', name)
      document.head.appendChild(meta)
    }
    meta.setAttribute('content', content)
  }

  // Update Open Graph tags
  updateOpenGraphTag('og:title', props.title)
  updateOpenGraphTag('og:description', props.description)
  updateOpenGraphTag('og:url', fullUrl)
  updateOpenGraphTag('og:image', props.image)
  updateOpenGraphTag('og:type', props.type)

  // Update Twitter Card tags
  updateTwitterTag('twitter:title', props.title)
  updateTwitterTag('twitter:description', props.description)
  updateTwitterTag('twitter:image', props.image)
}

// Update meta tags when component mounts
onMounted(() => {
  updateMetaTags()
})

// Watch for route changes
watch(() => route.path, () => {
  updateMetaTags()
})

// Watch for prop changes
watch(() => props, () => {
  updateMetaTags()
}, { deep: true })
</script>

<template>
  <div />
</template>
